import { Routes } from '@angular/router';
import { GeneralListComponent } from './adm-global-t/general-list/general-list.component';
import { GeneralFormComponent } from './adm-global-t/general-form/general-form.component';
import { AdmFormIntroInfoComponent } from '../shared/adm-form-intro-info/adm-form-intro-info.component';
import { AdmFormDocDptoComponent } from '../shared/adm-form-doc-dpto/adm-form-doc-dpto.component';
import { AdmFormDocSectorComponent } from '../shared/adm-form-doc-sector/adm-form-doc-sector.component';

export const TREND_ROUTES: Routes = [
    { path: 'list', component: GeneralListComponent },
    { path: 'add/:idtier1', component: GeneralFormComponent },
    { path: 'edit/:id', component: GeneralFormComponent },
    { path: 'add-info/:id', component: AdmFormIntroInfoComponent },
    { path: 'add-rep/:id', component: AdmFormDocDptoComponent },
    { path: 'add-rep-sec/:id', component: AdmFormDocSectorComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'list' }
];